import { tableData } from "@/app/shared/clients/customer-profile/recent-payments";
import GenericModal from "@/components/common/GenericModal";
import ControlledTable from "@/components/controlled-table";
import BasicTableWidget from "@/components/controlled-table/basic-table-widget";
import { HeaderCell } from "@/components/legacy-table";
import {
    fetchBillings,
    createBilling,
    deleteBilling,
    fetchBillingsByCustomer,
} from "@/server/api-services";
import { Billing } from "@/types";
import DateCell from "@/ui/date-cell";
import cn from "@/utils/class-names";
import { formatDate } from "@/utils/format-date";
import { toCurrency } from "@/utils/to-currency";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { Badge, Text } from "rizzui";

interface RecentPaymentsProps {
    customerId: string;
}

export default function RecentPayments({ customerId }: RecentPaymentsProps) {
    const getColumns = () => [
        {
            title: <span className="ms-6 block whitespace-nowrap">Date</span>,
            dataIndex: "createdDate",
            key: "createdDate",
            width: 200,
            render: (createdDate: string) => (
                <span className="ms-6 block">
                    <Text className="mb-1 font-medium text-gray-700">
                        {formatDate(new Date(createdDate), "MMMM D, YYYY")}
                    </Text>
                    <Text className="text-[13px] text-gray-500">
                        {formatDate(new Date(createdDate), "h:mm A")}
                    </Text>
                </span>
            ),
        },
        {
            title: <HeaderCell title="Billing Type" />,
            dataIndex: "billingType",
            key: "billingType",
            width: 200,
            render: (billingType: string) => <Text>{billingType}</Text>,
        },
        {
            title: <HeaderCell title="Billingd By" />,
            dataIndex: "client",
            key: "client",
            width: 200,
            render: (createdUser: string) => <Text>{createdUser}</Text>,
        },
        {
            title: <HeaderCell title="Remarks" />,
            dataIndex: "remarks",
            key: "remarks",
            width: 200,
            render: (remarks: string) => <Text>{remarks}</Text>,
        },
        {
            title: <HeaderCell title="Type" />,
            dataIndex: "debit",
            key: "debit",
            width: 200,
            render: (debit: number) => (
                <Badge variant="flat" color="success" size="sm">
                    {debit == 0 ? "Payment" : "Invoice"}
                </Badge>
            ),
        },
        {
            title: <HeaderCell title="debit" />,
            dataIndex: "debit",
            key: "debit",
            width: 200,
            render: (debit: number) => <Text>${debit}</Text>,
        },
        {
            title: <HeaderCell title="credit" />,
            dataIndex: "credit",
            key: "credit",
            width: 200,
            render: (credit: number) => <Text>${credit}</Text>,
        },
    ];

    const [billings, setBillings] = useState([] as Billing[]);

    useEffect(() => {
        if (customerId !== undefined) {
            getBillings();
        }
    }, [customerId]);

    async function getBillings() {
        const response = await fetchBillingsByCustomer(customerId);
        if (response.statusCode !== 200) {
            toast.error("Failed to fetch Billings");
            return;
        }

        var data = response.data as Billing[];

        data.sort(
            (a, b) =>
                new Date(b.createdDate).getTime() -
                new Date(a.createdDate).getTime(),
        );

        setBillings(data);
    }
    return (
        <ControlledTable
            data={billings}
            columns={getColumns()}
            scroll={{ x: "100%", y: 240 }}
            sticky={true}
            variant="modern"
            className="mt-4"
        />
    );
}
